import { ObjectValues } from 'types';

export const SUGGESTION_PAGE = {
  ENTERPRISE_DASHBOARD: 'Enterprise Dashboard',
  DATA_ROOM: 'Data Room',
} as const;

export type SuggestionPage = ObjectValues<typeof SUGGESTION_PAGE>;

export const GENERAL_SUGGESTED_ACTION_TYPE = {
  CONTACT_UPLOAD: 'contact_upload',
} as const;

export type GeneralSuggestedActionType = ObjectValues<
  typeof GENERAL_SUGGESTED_ACTION_TYPE
>;

export type GeneralSuggestedAction = {
  type: GeneralSuggestedActionType;
};

export const GENERAL_SUGGESTION_NAME = {
  CONTACT_UPLOAD: 'Upload Contacts',
} as const;

export type GeneralSuggestionName = ObjectValues<typeof GENERAL_SUGGESTION_NAME>;

export const GENERAL_SUGGESTION_ACTION = {
  CONTACTS_UPLOADED: 'Contacts uploaded',
} as const;

export type GeneralSuggestionAction = ObjectValues<
  typeof GENERAL_SUGGESTION_ACTION
>;

export type UserSuggestedActionSetting = {
  _id: string;

  userId: string;
  actionType: GeneralSuggestedActionType;
  isMuted: boolean;
  mutedUntil?: Date | null;
  mutedAt?: Date;

  createdAt: Date;
  updatedAt: Date;
};
